import { ReactNode } from "react"
import { PartnershipTierOverviewSection } from "../../../PartnershipTierOverviewSection"
import { PartnershipTierFeaturesSection } from "../../../PartnershipTierFeaturesSection"
import { BasePartnershipTierSelectorItemApplylistFragment } from "__generated__/BasePartnershipTierSelectorItemApplylistFragment"
import { BasePartnershipTierSelectorItemTierFragment } from "__generated__/BasePartnershipTierSelectorItemTierFragment"

type BasePartnershipTierSelectorItemProps = {
    applylist: BasePartnershipTierSelectorItemApplylistFragment
    partnershipTier: BasePartnershipTierSelectorItemTierFragment
    wrapper?: ReactNode
    cta: ReactNode
}

export const BasePartnershipTierSelectorItem = (
    props: BasePartnershipTierSelectorItemProps
) => {
    return (
        <>
            {props.wrapper}
            <PartnershipTierOverviewSection
                partnershipTier={props.partnershipTier}
                cta={props.cta}
                showOutline={!!props.wrapper}
            />
            <PartnershipTierFeaturesSection
                partnershipTier={props.partnershipTier}
                applylist={props.applylist}
                showOutline={!!props.wrapper}
            />
        </>
    )
}
